import { handleError } from "core/utils/HandleError";
import { handleResponse } from "core/utils/HandleResponse";
import { AuthHttpClient } from "core/utils/HttpClient";

export function getBracketDetails(tournamentId: any) {
  return AuthHttpClient.get(`/moderator/vs-mode/tournament/${tournamentId}`)
    .then(handleResponse)
    .catch(handleError);
}

export function getBracketTeams(tournamentId: any) {
  return AuthHttpClient.get(`/moderator/vs-mode/bracket/teams/${tournamentId}`)
    .then(handleResponse)
    .catch(handleError);
}

export function updateSchedule(data: any) {
  return AuthHttpClient.put(`/moderator/vs-mode/bracket/check-in`, data)
    .then(handleResponse)
    .catch(handleError);
}

export function updateResult(data: any) {
  return AuthHttpClient.post(`/moderator/vs-mode/result`, data)
    .then(handleResponse)
    .catch(handleError);
}

export function updateRoundRobinResult(data: any) {
  return AuthHttpClient.put(`/moderator/round-robin/result`, data)
    .then(handleResponse)
    .catch(handleError);
}

export function addRoundRobinResult(data: any) {
  return AuthHttpClient.post(`/moderator/round-robin/result`, data)
    .then(handleResponse)
    .catch(handleError);
}

export function bracketStandings(tournamentId: any) {
  return AuthHttpClient.get(`/moderator/round-robin/standings/${tournamentId}`)
    .then(handleResponse)
    .catch(handleError);
}

export function getBracketRoundRobinResult(bracketId: any) {
  return AuthHttpClient.get(`/moderator/round-robin/result/${bracketId}`)
    .then(handleResponse)
    .catch(handleError);
}

export function updateBulkSchedule(data: any) {
  return AuthHttpClient.post(`/moderator/vs-mode/bracket/bulk/check-in`, data)
    .then(handleResponse)
    .catch(handleError);
}

export function getBraceketDisputes(
  tournamentId: string | number,
  params: any
) {
  return AuthHttpClient.get(
    `/moderator/vs-mode/bracket/disputed/${tournamentId}`,
    {
      params,
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export function confirmBracketResult(data: any) {
  return AuthHttpClient.put(`/moderator/vs-mode/bracket/result/original`, data)
    .then(handleResponse)
    .catch(handleError);
}

export function bracketUserCheckIn(data: any) {
  return AuthHttpClient.put(`/moderator/vs-mode/bracket/checkin`, data)
    .then(handleResponse)
    .catch(handleError);
}
